import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";
import Constants from "../../Action/Constants";

class ActivityUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.GLOBAL_ACTIVITY_UPDATE_CLEAR
    });

    const id: number = parseInt(this.component.props.params.id, 10);

    this.component.props.dispatch({
      type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
      payload: {
        eventId: id
      },
      onSuccess: (activity: EventInterface) => {
        if (!activity) {
          return this.component.redirectBack();
        }

        this.component.initializePage(activity);
      },
      onError: this.component.redirectBack
    })
  }
}

export default new ActivityUpdateWillMount();
